import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaPlus } from 'react-icons/fa';
import { useModal } from '../../hooks/useModal';
import NewsPostTable from '../../components/layout/admin/NewsPostTable';
import SearchBar from '../../components/layout/admin/SearchBar';
import Pagination from '../../components/layout/admin/Pagination';
import CreateNewsPostModal from '../../components/layout/admin/CreateNewsPostModal';

interface NewsPost {
    id: string;
    slug: string;
    title: string;
    description: string;
    content: string;
    cover: string | object;
    tag: string;
    created_at: any;
    author: string;
    featured: boolean
}

export default function Nieuwsberichten() {
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [posts, setPosts] = useState<NewsPost[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const {isOpen, openModal, closeModal} = useModal();

    const postsPerPage = 10;

    const filteredPosts = posts.filter(post =>
        post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.tag.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.author.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredPosts.length / postsPerPage);
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get(`https://api.robinhoodboechout.be/api/v1/posts`);
                setPosts(response.data);
            } catch (error) {
                setError('Failed to fetch news posts');
                console.error(error);
            }
        };

        fetchPosts().then(() => {});
    }, [refreshTrigger]);

    const updatePage = (newPage: number) => {
        setCurrentPage(() => Math.max(1, Math.min(newPage, totalPages)));
    };

    if (error) {
        return <div className='py-16 flex flex-col items-center'>Error: {error}</div>;
    }
    return (
        <>
            <div className='relative flex flex-col w-full h-full text-gray-700 bg-white shadow-md rounded-xl bg-clip-border'>
                <div className='relative mx-4 mt-4 overflow-hidden text-gray-700 bg-white rounded-none bg-clip-border'>
                    <div className='flex items-center justify-between gap-8 mb-8'>
                        <div>
                            <h5 className='block font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900'>
                                Nieuwsberichten
                            </h5>
                            <p className='block mt-1 font-sans text-base antialiased font-normal leading-relaxed text-gray-700'>
                                Bekijk informatie over alle nieuwsberichten.
                            </p>
                        </div>
                        <div className='flex flex-col gap-2 shrink-0 sm:flex-row'>
                            <button
                                className='flex select-none items-center gap-3 rounded-lg bg-primary py-2 px-4 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none'
                                type='button'
                                onClick={() => openModal()}>
                                <FaPlus/>
                                Nieuwe Post
                            </button>
                        </div>
                    </div>
                    <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                </div>
                <NewsPostTable posts={currentPosts} />
                <Pagination currentPage={currentPage} totalPages={totalPages} setCurrentPage={updatePage} />
            </div>
            <CreateNewsPostModal isOpen={isOpen} closeModal={closeModal} refresh={() => setRefreshTrigger(prev => prev + 1)} />
        </>
    );
}